<template>
  <div id="menu-toggler" :class="{active: menuOpened }">
    <div class="stripes"
         @click="menuOpened = !menuOpened">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div id="nav-menu" :class="{active: menuOpened}">
      <nav>
        <!-- <a href="">關於 TESAS</a> -->
        <!-- <a href="./news.html">最新消息</a> -->
        <!-- <a href="">媒體報導</a> -->
        <!-- <a href="./cases.html">創生案例</a> -->
        <a target="_blank" href="https://youtu.be/y_N0gt4eONI">如何使用</a>
		<!-- <a href="./faq.html">常見問題</a> -->
        <!-- <a href="./how_to_use.html">如何使用</a> -->
        <a href="./related_sites.html">相關網站</a>
        <a href="./references.html">資料來源</a>
        <a href="./contact.html">聯絡我們</a>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuOpened: false
    }
  }
}
</script>

<style lang="scss">
@import "../css/custom_var";
@import "../css/custom_mixin";

#menu-toggler {
  width: 30px;
  height: 30px;
  margin: 0 30px;
  cursor: pointer;
  @include border-radius(2px);
  @include flex-center();

  &.active {
    background-color: #eee;
  }

  .stripes {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 24px;
    height: 14px;
    span {
      width: 100%;
      height: 2px;
      background-color: $ts-green;
    }
  }
}

#nav-menu {
  position: absolute;
  width: 450px;
  padding: 30px 0;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: -4px 8px 6px -6px #999;
  @include transition(right 0.3s ease);
  right: -450px;
  top: 40px;
  z-index: 200;
  &.active {
    right: 0;
  }

  nav {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    a {
      font-size: 1.3rem;
      line-height: 1.3;
      width: 152px;
      padding-bottom: 5px;
      text-align: center;
      margin-bottom: 28px;
      &:hover {
        border-bottom: 2pt solid black;
        padding-bottom: calc(5px - 2pt);
      }
    }

    :nth-last-child(1) {
      margin-bottom: 0;
    }
  }
}
</style>
